/**
 * Divider Component
 *
 * Extracted from Figma Crop Circle System
 * Node ID: 523-1654
 *
 * A simple line separator for visual content division.
 * Supports horizontal/vertical orientation.
 * Color: Slate-100 (#ECEEF1)
 */

import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { Colors } from '../../../../themes/colors';

export type DividerType = 'horizontal' | 'vertical';

export interface DividerProps {
  /**
   * Orientation of the divider
   * @default "horizontal"
   */
  type?: DividerType;

  /**
   * Custom length (width for horizontal, height for vertical)
   * Defaults to 100% of parent
   */
  length?: number | string;

  /**
   * Custom style overrides
   */
  style?: ViewStyle;

  /**
   * Test identifier
   */
  testID?: string;
}

const DIVIDER_THICKNESS = 1;
const DIVIDER_COLOR = Colors.role.borderSection;

export const Divider: React.FC<DividerProps> = ({
  type = 'horizontal',
  length,
  style,
  testID,
}) => {

  const dividerStyle: ViewStyle =
    type === 'horizontal'
      ? {
          height: DIVIDER_THICKNESS,
          width: length ?? '100%',
          backgroundColor: DIVIDER_COLOR,
        }
      : {
          width: DIVIDER_THICKNESS,
          height: length ?? '100%',
          backgroundColor: DIVIDER_COLOR,
        };

  return (
    <View
      style={[styles.divider, dividerStyle, style]}
      testID={testID}
      accessibilityRole="none"
    />
  );
};

Divider.displayName = 'Divider';

const styles = StyleSheet.create({
  divider: {
    flexShrink: 0,
  },
});
